import Link from 'next/link'

import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import Panel from '@/components/Panel/Panel'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'

const NotFoundPage = () => (
  <Main>
    <Container small>
      <ExplicitHead description='Page not found.' keywords='404' noindex title='Not Found' />
      <SimpleHeader>404 Page Not Found</SimpleHeader>
      <Panel>
        <p>New cards take a few days to show up on EDHREC.</p>
        <p>If what you&apos;re looking for was recently previewed, check back soon!</p>
        <p>
          For any other issues, please submit a bug report <Link href='/bug-report'>here</Link>.
        </p>
      </Panel>
    </Container>
  </Main>
)

export default NotFoundPage
